/** @format */
import { Trans, useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import {
    isConditionSparesAndRepairs,
    productConditionEnumToText,
} from '@toucan/client/global/product';

import { Link } from '@toucan/client/shared/components/link';
// eslint-disable-next-line boundaries/element-types
import { useProductConditionDescriptionModal } from '@toucan/client/shared/hooks/use-product-condition-description-modal';

import { DEFAULT_TEST_ID } from './constants';
import { styles } from './formatted-condition.styles';
import { FormattedConditionProps } from './types';

const StyledFormattedCondition = styled.span`
    ${styles}
`;

export const FormattedCondition: FunctionComponent<FormattedConditionProps> = ({
    condition,
    conditionDescription,
    boldConditionValue = true,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => {
    const { t } = useTranslation();

    const { showProductConditionDescriptionModal } =
        useProductConditionDescriptionModal();

    const conditionText = productConditionEnumToText(t, condition);

    return (
        <StyledFormattedCondition
            {...otherProps}
            data-testid={dataTestId}
            $boldConditionValue={boldConditionValue}
        >
            <Trans
                components={{
                    'condition-wrapper': conditionDescription ? (
                        <Link
                            className="condition-wrapper"
                            data-testid={`${dataTestId}__condition-description-modal-link`}
                            onClick={() =>
                                showProductConditionDescriptionModal(
                                    condition,
                                    conditionDescription
                                )
                            }
                        />
                    ) : (
                        <span className="condition-wrapper" />
                    ),
                }}
            >
                {isConditionSparesAndRepairs(condition)
                    ? t(
                          'Condition: <condition-wrapper>{{condition}}</condition-wrapper>',
                          { condition: conditionText }
                      )
                    : t(
                          'Cosmetic condition: <condition-wrapper>{{condition}}</condition-wrapper>',
                          { condition: conditionText }
                      )}
            </Trans>
        </StyledFormattedCondition>
    );
};
